import { CloseFormsReason } from '../../../AccountConfig';
import { ParsedRequirementNode } from '../../../Common/Parsers/RequirementNodeParser';

const formsUIWrapper = {
	showForm(
		requirements: ParsedRequirementNode[],
		prepopulatedCredentials: string,
		referenceUri: string,
		store: {
			name: string;
			url: string;
		},
		timeoutSeconds: number | null
	): void {
		window.formsUI.showForm({
			requirements,
			prepopulatedCredentials,
			referenceUri,
			store,
			timeoutSeconds,
		});
	},
	updateForm(requirements: ParsedRequirementNode[]): void {
		window.formsUI.updateForm({ requirements });
	},
	closeForm(reason: CloseFormsReason): void {
		window.formsUI.closeForm({ reason });
	},
};
export default formsUIWrapper;
